// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const StepsWrapper: StatelessFunctionalComponent<*> = styled.div`
  position: relative;

  .Steps {
    text-align: center;
    padding-top: 10px;
    position: relative;

    &-backButton {
      margin: 6px 6px;
      position: absolute;
      left: 0;
      z-index: 2;
      font-size: 18px !important;
    }

    @media (max-width: 700px){
      &-padTop-4{
        padding-top: 60px;
      }
    }

    @media (max-width: 530px){
      &-padTop-2{
        padding-top: 60px;
      }
    }

    &-step {
      display: inline-block;
    }

    &-step-on {
      opacity: 1;
      background-color: var(--blue-color);
    }

    &-step-off {
      opacity: 0.1;
      background-color: var(--black-color);
    }

    &-step-text {
      /* width: 91px; */
      width: 150px;
      height: 17px;
      line-height: 3;
      font-size: 14px;
      font-weight: 500;
      color: #acacac;
    }

    &-step-text-on {
      font-size: 14px;
      font-weight: 900;
      color: var(--blue-color);
    }

    &-circle {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      display: inline-block;
    }

    &-line {
      /* width: 70px; */
      width: 124px;
      height: 3px;
      border-radius: 5px;
      margin-top: 5px;
      /* margin-left: -34.5px; */
      margin-left: -61px;
      position: absolute;
    }

    @media (max-width: 530px){
      display: flex;
      justify-content: center;
      flex-direction: row;
      flex-wrap: wrap;

      &-line {
        display: none;
      }

      &-step {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

      }

      &-step-text {
        width: auto;
        height: auto;
        font-size: 14px;
      }

      &-circle {
        margin-left: 10px;
        margin-right: 10px;
      }
    }
  }
`;

export default StepsWrapper;
